module.exports = __webpack_public_path__ + "static/img/3-10.bb34638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-10.jpg
// module id = i3Aw
// module chunks = 1